/* Han 22 Oct presentation, retaining Shopify navigation and native drawer controls. */
(() => {
  if (window.hanContentNavLoaded) return;
  window.hanContentNavLoaded = true;
  const fine = matchMedia('(hover:hover) and (pointer:fine)');
  const closeContent = except => document.querySelectorAll('.han-content-menu[open]').forEach(menu => {if(menu !== except)menu.open=false});
  function init(root=document){
    root.querySelectorAll('.shopify-section-header').forEach(header=>{
      if(header.dataset.hanSharedReady)return;header.dataset.hanSharedReady='true';
      let timer;
      const syncHeight=()=>{const panel=header.querySelector('.burger-menu__dropdown-wrapper');if(panel)header.style.setProperty('--han-shared-menu-height',`${panel.offsetHeight}px`)};
      const observer=new ResizeObserver(syncHeight);
      const panel=header.querySelector('.burger-menu__dropdown-wrapper');if(panel)observer.observe(panel);
      syncHeight();
      header.addEventListener('pointerenter',()=>clearTimeout(timer));
      header.addEventListener('pointerleave',event=>{
        if(!fine.matches||event.pointerType==='touch')return;
        timer=setTimeout(()=>{if(header.matches(':hover')||header.contains(document.activeElement))return;closeContent();header.querySelectorAll('burger-menu').forEach(shop=>{if(shop.querySelector('.burger-menu--open'))shop.close?.(new Event('han:close-menu'))})},240);
      });
      document.addEventListener('shopify:section:unload',event=>{if(event.target.contains(header)){observer.disconnect();clearTimeout(timer)}},{once:true});
    });
    root.querySelectorAll('.han-content-menu').forEach(menu=>{
      if(menu.dataset.hanReady)return;menu.dataset.hanReady='true';
      const summary=menu.querySelector('summary');
      const closeShop=()=>document.querySelectorAll('burger-menu').forEach(shop=>{if(shop.querySelector('.burger-menu--open'))shop.close?.(new Event("han:close-menu"))});
      const open=()=>{closeContent(menu);closeShop();menu.open=true};
      summary.addEventListener('mouseenter',()=>{if(fine.matches)open()});
      summary.addEventListener('click',event=>{event.preventDefault();open()});
      summary.addEventListener('keydown',event=>{if(event.key==='ArrowDown'){event.preventDefault();open();menu.querySelector('a')?.focus()}});
      
      menu.addEventListener('focusout',()=>{requestAnimationFrame(()=>{if(!menu.contains(document.activeElement)&&!menu.matches(':hover'))menu.open=false})});
    });
    root.querySelectorAll('burger-menu').forEach(shop=>{
      if(shop.dataset.hanPaneReady)return;shop.dataset.hanPaneReady='true';
      shop.querySelectorAll('.burger-menu__hover--open-btn,.burger-menu__toggle--open-btn').forEach(trigger=>{
        trigger.addEventListener('mouseenter',()=>closeContent());trigger.addEventListener('click',()=>closeContent());
      });
    });
    root.querySelectorAll('.han-mobile-menu-tabs').forEach(tabs=>{
      if(tabs.dataset.hanReady)return;
      const list=tabs.nextElementSibling;
      if(!list?.querySelector('[data-han-about-pane]'))return;
      tabs.dataset.hanReady='true';tabs.hidden=false;
      const select=pane=>{
        tabs.querySelectorAll('button').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.hanMenuPane===pane)));
        [...list.children].forEach(item=>{item.hidden=(pane==='about')!==item.hasAttribute('data-han-about-pane')});
      };
      tabs.addEventListener('click',event=>{const button=event.target.closest('[data-han-menu-pane]');if(button)select(button.dataset.hanMenuPane)});
      select('shop');
    });
  }
  document.addEventListener('click',event=>{document.querySelectorAll('.han-content-menu[open]').forEach(menu=>{if(!menu.contains(event.target))menu.open=false})});
  document.addEventListener('keydown',event=>{if(event.key!=='Escape')return;document.querySelectorAll('.han-content-menu[open]').forEach(menu=>{const restore=menu.contains(document.activeElement);menu.open=false;if(restore)menu.querySelector('summary').focus()})});
  init();document.addEventListener('shopify:section:load',event=>init(event.target));
})();
